import { VK } from './define'

const HidModifierKeys: Map<number, number> = new Map([
  [0xa0, 0x02], //L-Shift
  [0xa1, 0x20], //R-Shift
  [0xa2, 0x01], //L-Ctrl
  [0xa3, 0x10], //R-Ctrl
  [0xa4, 0x04], //L-Alt
  [0xa5, 0x40], //R-Alt
  [0x5b, 0x08], //L-Win
  [0x5c, 0x80], //R-Win
])

enum HidCombinationKeys {
  CTRL_L = 0x01,
  Shift_L = 0x02,
  Alt_L = 0x04,
  Win_L = 0x08,
  Ctrl_R = 0x10,
  Shift_R = 0x20,
  Alt_R = 0x40,
  Win_R = 0x80,
}

export function encodeCombinationKeys(keys: VK[]) {
  let combination = 0
  for (const key of keys) {
    const ctrlKey = HidModifierKeys.get(key)
    if (ctrlKey && ctrlKey & (HidCombinationKeys.CTRL_L | HidCombinationKeys.Ctrl_R)) {
      combination += HidCombinationKeys.CTRL_L
    }
    const shiftKey = HidModifierKeys.get(key)
    if (shiftKey && shiftKey & (HidCombinationKeys.Shift_L | HidCombinationKeys.Shift_R)) {
      combination += HidCombinationKeys.Shift_L
    }
    const altKey = HidModifierKeys.get(key)
    if (altKey && altKey & (HidCombinationKeys.Alt_L | HidCombinationKeys.Alt_R)) {
      combination += HidCombinationKeys.Alt_L
    }
    const winKey = HidModifierKeys.get(key)
    if (winKey && winKey & (HidCombinationKeys.Win_L | HidCombinationKeys.Win_R)) {
      combination += HidCombinationKeys.Win_L
    }
  }
  return combination
}

export function decodeHidCombinationKeys(_combination: number) {
  // const keys: number[] = [];
  // if (combination & CombinationKeys.CTRL_L) {
  //     const [key, exist] = VKFromDVK(CombinationKeys.CTRL_L, deviceManager.deviceID);
  //     if (exist) {
  //         keys.push(key);
  //     }
  // }
  // if (combination & CombinationKeys.Shift_L) {
  //     const [key, exist] = VKFromDVK(CombinationKeys.Shift_L, deviceManager.deviceID);
  //     if (exist) {
  //         keys.push(key);
  //     }
  // }
  // if (combination & CombinationKeys.Alt_L) {
  //     const [key, exist] = VKFromDVK(CombinationKeys.Alt_L, deviceManager.deviceID);
  //     if (exist) {
  //         keys.push(key);
  //     }
  // }
  // if (combination & CombinationKeys.Win_L) {
  //     const [key, exist] = VKFromDVK(CombinationKeys.Win_L, deviceManager.deviceID);
  //     if (exist) {
  //         keys.push(key);
  //     }
  // }
  // return keys;
}

export const IsModifierKey = (key: VK) => {
  if (HidModifierKeys.get(key)) {
    return true
  }
  return false
}
